import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AmToasterService } from '@angularminds/am-toaster';
import { GeneralService } from 'src/app/services/general.service';
import { RestService } from 'src/app/services/rest.service';
import * as _ from 'lodash'

@Component({
  selector: 'app-current-wallet',
  templateUrl: './current-wallet.component.html',
  styleUrls: ['./current-wallet.component.css']
})
export class CurrentWalletComponent implements OnInit {

  cWallets: any = [];
  // walletId: any = "";
  @Input() walletId:any;
  @Output() wallet = new EventEmitter<any>()
  constructor(
    private restService: RestService,
    private amToasterService: AmToasterService,
  ) { }

  ngOnInit(): void {
    this.getCurrentUserWallets()
  }

  getCurrentUserWallets() {
    this.restService.fetch(`/api/wallets/current`).subscribe(res => {
      console.log('res:==>> ', res);
      if (res && res.length) {
        this.cWallets = res
      } else {
        this.amToasterService.show("error", "Wallets not found", "Error")
      }
    }, err => {
      this.amToasterService.show("error", "Error in finding wallets", "Error")
    })
  }

  setCurrentWallet(walletId) {
    const walletResp: any = _.find(this.cWallets, (cWallet) => {
      return (cWallet._id) + "" == walletId + ""
    })
    this.wallet.emit(walletResp)
  }

}
